import { render, staticRenderFns } from "./MemberCenterAdminActiveNoticesList.vue?vue&type=template&id=2a2f2b67&lang=pug&"
import script from "./MemberCenterAdminActiveNoticesList.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminActiveNoticesList.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminActiveNoticesList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports